module.exports = __webpack_public_path__ + "media/images/front/brands/avant_garde/avant_garde_2-8ec8cc0eb5b4824f68f9564a0d4b6661.jpg";